import { removeSourceAndLayers, setVisibility } from '../utils/maplibre-helpers';

export default class BaseLayer {
    static ID = 'layer';
    static MIN_ZOOM = 0;
    static MAX_ZOOM = 22;

    constructor(config = {}) {
        this.config = config;
        this.id = config.id || this.constructor.ID;
        this.minZoom = config.minZoom != null ? config.minZoom : this.constructor.MIN_ZOOM;
        this.maxZoom = config.maxZoom != null ? config.maxZoom : this.constructor.MAX_ZOOM;
    }

    getMap() {
        return this.config.getMap ? this.config.getMap() : null;
    }

    getSourceId() {
        return 'src-' + this.id;
    }

    getLayerIds() {
        return this.config.getLayerIds ? this.config.getLayerIds() : [this.id];
    }

    getToggleEl() {
        return this.config.getToggleEl ? this.config.getToggleEl() : null;
    }

    isActive() {
        return this.config.getActive ? !!this.config.getActive() : true;
    }

    setActive(value) {
        if (this.config.setActive) {
            this.config.setActive(!!value);
        }
        this.updateToggleState();
    }

    isDesired() {
        return this.config.getDesired ? !!this.config.getDesired() : this.isActive();
    }

    setDesired(value) {
        if (this.config.setDesired) {
            this.config.setDesired(!!value);
        }
        this.updateDisabledState();
    }

    canActivate() {
        const map = this.getMap();
        return !!map && Math.round(map.getZoom() * 10) / 10 >= this.minZoom;
    }

    updateToggleState() {
        const toggleEl = this.getToggleEl();
        if (toggleEl) {
            toggleEl.classList.toggle('is-active', this.isActive());
        }
    }

    updateDisabledState() {
        const toggleEl = this.getToggleEl();
        if (!toggleEl) {
            return;
        }

        const map = this.getMap();
        const zoom = map ? Math.round(map.getZoom() * 10) / 10 : 0;
        toggleEl.classList.toggle('is-disabled', zoom < this.minZoom);
        toggleEl.classList.toggle('is-desired', this.isDesired());
        toggleEl.setAttribute('aria-checked', this.isDesired() ? 'true' : 'false');
    }

    notifyStateChange() {
        if (this.config.onStateChange) {
            this.config.onStateChange(this);
        }
    }

    toggle(options = {}) {
        if (!this.getMap()) {
            return false;
        }

        const nextDesired = !this.isDesired();
        const nextActive = nextDesired && this.canActivate();
        this.setActive(nextActive);
        this.setDesired(nextDesired);

        if (nextActive) {
            this.load();
        } else {
            this.clear();
        }

        if (options.notify !== false) this.notifyStateChange();
        return true;
    }

    syncVisibility() {
        if (!this.getMap()) {
            return;
        }

        if (this.canActivate()) {
            if (!this.isActive() && this.isDesired()) {
                this.setActive(true);
                this.load();
            }
        } else if (this.isActive()) {
            this.setActive(false);
            this.clear();
        }

        this.updateToggleState();
        this.updateDisabledState();
    }

    removeLayerFromMap() {
        const map = this.getMap();
        if (!map) return;
        removeSourceAndLayers(map, this.getSourceId(), this.getLayerIds());
    }

    load() {}

    clear() {
        this.removeLayerFromMap();
    }
}
